import { render, staticRenderFns } from "./textEffect.vue?vue&type=template&id=51421a8d&scoped=true"
import script from "./textEffect.vue?vue&type=script&lang=js"
export * from "./textEffect.vue?vue&type=script&lang=js"
import style0 from "./textEffect.vue?vue&type=style&index=0&id=51421a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51421a8d",
  null
  
)

export default component.exports